export default __webpack_public_path__ + "static/media/s16.74876cb0.jpg";